import { ActionType, getType } from 'typesafe-actions';

import * as currentOrderActions from '../actionCreators/currentOrder';
import * as memberActions from '../actionCreators/member';

const initialState = null;

export default function (
  state: HistoricalOrder[] | null = initialState,
  action: ActionType<typeof currentOrderActions | typeof memberActions>,
): HistoricalOrder[] | null {
  switch (action.type) {
    case getType(currentOrderActions.resetOrder): {
      const { preserveMember } = action.payload;
      return preserveMember ? state : initialState;
    }
    case getType(memberActions.setHistoricalOrders): {
      const { value } = action.payload;
      return value == null ? initialState : value;
    }
    default:
      return state;
  }
}
